<div class="d-flex flex-column flex-root login-container">
    <div class="d-flex flex-column flex-lg-row flex-column-fluid">
        <div class="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center" style="background-image: url(assets/media/misc/Abacus-Login-Image.jpg)">
        </div>
        <div class="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10">
            <div class="d-flex flex-center flex-column flex-lg-row-fluid">
                <div class="w-lg-500px p-10">
                    <div class="logo-container">
                    <a href="#" class="mb-0 mb-lg-5 text-center d-flex justify-content-center" draggable="false">
                        <img alt="Logo" src="assets/media/logos/alchemy-logo.png" (click)="navigate()" class="h-490px h-lg-90px mb-5" draggable="false">
                    </a>
                </div>
                    <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" class="form w-100" novalidate="novalidate" action="#">
                        <div class="text-left mb-11">
                            <h1 class="text-light-bluish-gray fw-bolder mb-3 login1">{{ heading() }}</h1>
                        </div>
                        <div class="fv-row position-relative" [class.mb-8]="!(forgotPasswordForm.get('newPassword')?.invalid && forgotPasswordForm.get('newPassword')?.touched)" [class.mb-0]="forgotPasswordForm.get('newPassword')?.invalid && forgotPasswordForm.get('newPassword')?.touched">
                            <label class="form-label form-label-floating reverse required">New password</label>
                            <input type="password" placeholder="" formControlName="newPassword" autocomplete="off" class="form-control bg-transparent pass" max-length="64" />
                        </div>
                        
                        @if (forgotPasswordForm.get('newPassword')?.invalid && forgotPasswordForm.get('newPassword')?.touched) {
                            <div class="text-danger password-error-message mb-3">
                                @if (forgotPasswordForm.get('newPassword')?.errors?.['required']) {
                                    <div>New Password is required.</div>
                                }
                                @else if (forgotPasswordForm.get('newPassword')?.errors?.['minlength']) {
                                    <div>
                                        <div class="mb-2">Password must meet the following requirements:</div>
                                        <ul class="mb-0 ps-4">
                                            <li>Minimum 8 characters, maximum 64 characters</li>
                                            <li>Minimum 1 upper case</li>
                                            <li>Minimum 1 special character</li>
                                            <li>Password must be different from previous password</li>
                                        </ul>
                                    </div>
                                }
                                @else if (forgotPasswordForm.get('newPassword')?.errors?.['maxlength']) {
                                    <div>
                                        <div class="mb-2">Password must meet the following requirements:</div>
                                        <ul class="mb-0 ps-4">
                                            <li>Minimum 8 characters, maximum 64 characters</li>
                                            <li>Minimum 1 upper case</li>
                                            <li>Minimum 1 special character</li>
                                            <li>Password must be different from previous password</li>
                                        </ul>
                                    </div>
                                }
                            </div>

                            @if (forgotPasswordForm.get('newPassword')?.errors?.['pattern'] && !forgotPasswordForm.get('newPassword')?.errors?.['required'] 
                                && !forgotPasswordForm.get('newPassword')?.errors?.['minlength'] && !forgotPasswordForm.get('newPassword')?.errors?.['maxlength']) {
                                <div class="text-danger password-error-message mb-3">
                                    <div>
                                        <div class="mb-2">Password must meet the following requirements:</div>
                                        <ul class="mb-0 ps-4">
                                            <li>Minimum 8 characters, maximum 64 characters</li>
                                            <li>Minimum 1 upper case</li>
                                            <li>Minimum 1 special character</li>
                                            <li>Password must be different from previous password</li>
                                        </ul>
                                    </div>
                                </div>
                            }
                        }
                        
                        <div class="fv-row mb-3 position-relative">
                            <label class="form-label form-label-floating reverse required">Re-enter New Password</label>
                            <input type="password" placeholder="" formControlName="confirmPassword" autocomplete="off" class="form-control bg-transparent pass" maxlength="64"/>
                        
                            @if (forgotPasswordForm.get('confirmPassword')?.invalid && forgotPasswordForm.get('confirmPassword')?.touched) {
                                <div class="text-danger">
                                    @if (forgotPasswordForm.get('confirmPassword')?.errors?.['required']) {
                                        Please confirm your new password.
                                    }
                                    @else if (forgotPasswordForm.get('confirmPassword')?.errors?.['maxlength']) {
                                        Password must be no longer than 64 characters.
                                    }
                                    @else if (forgotPasswordForm.get('confirmPassword')?.errors?.['minlength']) {
                                        Password must be at least 8 characters long.
                                    }
                                    @else if (forgotPasswordForm.get('confirmPassword')?.errors?.['maxlength']) {
                                        Password must be no longer than 64 characters.
                                    }
                                </div>
                            }@else if (!forgotPasswordForm.get('confirmPassword')?.invalid && forgotPasswordForm.get('confirmPassword')?.touched
                                && forgotPasswordForm.errors?.['passwordMismatch']) {
                                <div class="text-danger"> Passwords do not match.</div>
                            }
                        </div>        
                        
                        <!-- <div *ngIf="isLoading" class="loader-container">
                            <mat-progress-spinner [diameter]="30" mode="indeterminate"></mat-progress-spinner>
                            <span class="loader-text">please wait...</span>
                        </div>  -->
                        
                        <div *ngIf="responseMessage" class="response-message">
                            {{ responseMessage }} 
                        </div>
                        @if(responseErrorMessage()){
                            <div class="response-errmessage mb-3">{{ responseErrorMessage() }} </div>
                        }

                        @if(invalidErrorResponse()){
                            <div class="response-errmessage mb-3">{{ invalidErrorResponse() }} </div>
                        }
             
                        
                        <div class="d-grid mb-10">
                            <button type="submit" class="btn btn-primary" [disabled]="forgotPasswordForm.invalid || this.responseErrorMessage()">
                                <span class="indicator-label">{{ buttonText() }}</span>
                            </button>
                        </div>
                      </form>
                </div>
            </div>
            <div class="d-flex flex-center flex-wrap px-5">
        <div class="d-flex fw-semibold text-light-gray fs-base">
            <span class="px-5" target="_blank">© 2025 Alchemy Underwriting. All rights reserved.</span>
        </div>
    </div>
        </div>
    </div>
</div>